/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Faq1q1Inputs */

const zh_pricing_faq1q1 = /** @type {(inputs: Pricing_Faq1q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费版有什么限制？`)
};

const en_pricing_faq1q1 = /** @type {(inputs: Pricing_Faq1q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What are the limitations of the Free plan?`)
};

const es_pricing_faq1q1 = /** @type {(inputs: Pricing_Faq1q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuáles son las limitaciones del plan Gratis?`)
};

/**
* | output |
* | --- |
* | "What are the limitations of the Free plan?" |
*
* @param {Pricing_Faq1q1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const pricing_faq1q1 = /** @type {((inputs?: Pricing_Faq1q1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Faq1q1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_pricing_faq1q1(inputs)
	if (locale === "en") return en_pricing_faq1q1(inputs)
	return es_pricing_faq1q1(inputs)
});
export { pricing_faq1q1 as "pricing_faq1Q" }